import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactQuill from "react-quill";
import { IoArrowBackOutline } from "react-icons/io5";
import axios from "axios";
import { server_API } from "../config";
import { useSelector } from "react-redux";
import { selectCid } from "../features/companyid";
import { toast, ToastContainer } from "react-toastify";
import { ToastIcon } from "../components/TestOfferInitiation";

const DocumentReq = () => {
  const cid = useSelector(selectCid);
  const [companyCountryCode, setCompanyCountryCode] = useState("");
  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${server_API}/v2/company/geturl/${cid}`)
      .then((response) => {
        console.log(response);
        setLogo(response.data.url);
      })
      .catch((err) => {
        console.log(err);
      });

    if (cid) {
      axios
        .get(`${server_API}/v2/company/get/${cid}`)
        .then((response) => {
          if (response.data.company_countries && response.data.company_countries.length > 0) {
            setCompanyCountryCode(response.data.company_countries[0]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [cid]);
  const [templateType, setTemplateType] = useState([]);

  const defaultDocuments = [
    "Photo",
    "Aadhar Card",
    "Pan Card",
    "3 months salary slip",
    "Education Certificate",
  ].filter(doc => companyCountryCode !== "GB" || (doc !== "Aadhar Card" && doc !== "Pan Card"));

  const sendEmail = () => {
    toast.success(
      "Document request email has been successfully sent to the candidate.",{icon:<ToastIcon/>}
    );
  };
  const [requiredDocuments, setRequiredDocuments] = useState(new Map());
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [files, setFiles] = useState([]);
  const [logo, setLogo] = useState(null);

  return (
    <div className="bg-[#f0f4fc] min-h-screen">
      <ToastContainer></ToastContainer>
      <div className="p-4 md:px-10 pt-5">
        <div className="flex gap-4 items-center">
          <Link to="/jobs/candidates">
            {" "}
            <IoArrowBackOutline className="w-7 cursor-pointer h-7 " />
          </Link>
          <p className="text-[28px] font-semibold">
            Documents request email to candidate
          </p>
        </div>
        <div className=" rounded-xl mt-6 bg-white  shadow-2xl">
          <div className="flex">
            <div className="w-1/2 py-4 px-6">
              <p className="font-semibold">
                Email Template <span className="text-red-500">*</span>
              </p>
              <select
                value={templateType}
                onChange={(e) => {
                  setTemplateType(e.target.value);
                }}
                className="border border-r-[30px]  px-1 py-2 rounded-lg mt-2 w-full"
              >
                <option value=""> </option>
                <option value="Sales">Sales</option>
                <option value="Engineering">Engineering</option>
                <option value="Design">Design</option>
                <option value="Marketing">Marketing</option>
                <option value="Finance">Finance</option>
              </select>
              <p className="font-semibold mt-4">
                Documents required <span className="text-red-500">*</span>
              </p>
              <div className="flex flex-wrap w-full gap-4 mt-3">
                {defaultDocuments.map((d) => {
                  return (
                    <button
                      onClick={() => {
                        requiredDocuments.has(d)
                          ? setRequiredDocuments((prevMap) => {
                              const newMap = new Map(prevMap);
                              newMap.delete(d);
                              return newMap;
                            })
                          : setRequiredDocuments(
                              (map) => new Map(map.set(d, ""))
                            );
                      }}
                      className={
                        requiredDocuments.has(d)
                          ? "bg-[#148EFF33] border-2 border-[#148EFF] text-[#148EFF]  p-1 font-semibold text-sm rounded-lg"
                          : "bg-[#8F94A133] border-2 border-[#8F94A1] text-[#8F94A1]  p-1 font-semibold text-sm rounded-lg"
                      }
                    >
                      {d}
                    </button>
                  );
                })}
              </div>
              <button className="text-[#148EFF] text-xs mt-3 font-semibold">
                + Add More
              </button>

              <div className="mt-5 space-y-4">
                <p className="font-semibold">Email Customisation</p>
                <div>
                  <p className="font-semibold">Subject</p>
                  <input
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                    value={subject}
                    className=" outline-none border px-2 py-2 w-full rounded-lg mt-2"
                  ></input>
                </div>

                <div>
                  <p className="font-semibold">Email body</p>
                  <ReactQuill
                    value={body}
                    onChange={setBody}
                    rows="5"
                    theme="snow"
                    className=" w-full rounded-xl py-2  mt-2"
                  ></ReactQuill>
                </div>
                <div>
                  <p>Attachments</p>
                  <input
                    type="file"
                    onChange={(e) => {
                      setFiles(e.target.files);
                    }}
                    multiple
                  ></input>
                </div>
              </div>
            </div>
            <div className="w-1/2 bg-[#f0f4fc] py-4 px-6">
              <p className="font-semibold">Email Preview</p>
              <div className="bg-white mt-3 rounded-lg p-4">
                {logo && <img src={logo} className="h-16"></img>}
                <ReactQuill
                  value={body}
                  rows="10"
                  readOnly
                  theme="bubble"
                ></ReactQuill>
              </div>
            </div>
          </div>
          <div className="bg-white text-right rounded-b-lg px-6 py-4">
            <button
              className="rounded-lg bg-[#148EFF] px-4 py-2 text-white"
              onClick={sendEmail}
            >
              Send Email
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentReq;
